import { createDeck, drawCards } from './deck'
import { TOTAL_CARD_POINTS } from './constants'
import { CONTENT_TYPE } from '@educaplay/core'

const getCardType = (text, mediaSource, mediaType) => {
    let cardTypeSuffix = '';
    if (text !== '') cardTypeSuffix += 'text';
    if (mediaSource !== undefined) {
        if (cardTypeSuffix !== '') cardTypeSuffix += '-';
        cardTypeSuffix += mediaType;
    }

    return `card-${cardTypeSuffix}`;
}

export const createQuestions = ({filteredQuestions, incorrectAnswers, resources, liveActived }) => {
    const cardNumber = filteredQuestions.flatMap((question) => question.RESPUESTAS).length;
    const pointsPerCard = TOTAL_CARD_POINTS / cardNumber;

    const initialCards = filteredQuestions.flatMap((question) => {
        return question.RESPUESTAS.map((card, index) => {
            const cardType = getCardType(card.RESPUESTA, card.MULTIMEDIA, card.MULTIMEDIA_TIPO);

            return {
                originId: index,
                text: card.RESPUESTA,
                source: card.MULTIMEDIA ? `${resources}${card.MULTIMEDIA}` : null,
                cardType,
                type: card.MULTIMEDIA_TIPO ?? null,
                answer: card.RESPUESTA,
                group: question.groupId,
                points: pointsPerCard
            }
        });
    })

    const decoyCards = incorrectAnswers.map((card, index) => {
        const cardType = getCardType(card.RESPUESTA, card.MULTIMEDIA, card.MULTIMEDIA_TIPO);

        return {
            originId: index,
            text: card.RESPUESTA,
            source: card.MULTIMEDIA ? `${resources}${card.MULTIMEDIA}` : null,
            cardType,
            type: card.MULTIMEDIA_TIPO ?? null,
            answer: card.RESPUESTA,
            group: -1,
            points: 0
        }
    });

    const questions = filteredQuestions.map((question) => {
        let deck = createDeck([...initialCards, ...decoyCards]);
        const questionData = [];
        do {
            deck = createDeck(deck);

            const questionGrid = drawCards(deck, question.id);

            const groupCards = questionGrid.filter(card => card.group === question.id);
            const correctAnswers = groupCards.map(card => card.originId);

            const correctIdAnswers = groupCards.map(card => card.id);
            const points = groupCards.reduce((acc, card) => acc + card.points, 0);

            const checkAnswer = (arrayAnswer) => {
                return correctIdAnswers.every((value) => arrayAnswer.answer.includes(value));
            }

            const calculatePoints = (_userAnswer, { tries = [] }) => {
                if (!liveActived) return points;
                if (tries.length === 0) return points;
                if (tries.length === 1) return points / 2;
                if (tries.length === 2) return points / 4;
                return 0;
            }

            questionData.push({
                text: question.ENUNCIADO,
                bank: {
                    text: question.ENUNCIADO,
                    type: CONTENT_TYPE.TEXT
                },
                checkAnswer,
                correctAnswers,
                correctIdAnswers,
                answer: null,
                calculatePoints,
                points,
                id: question.id,
                grid: questionGrid,
                answers: questionGrid.map(card => {
                    if(card.group !== question.id) return card;
                    return {...card, id: card.originId}
                })
            });

            deck = deck.filter((card) => !correctIdAnswers.includes(card.id));
        } while (deck.some((card) => card.group === question.id))

        return questionData;
    }).flat();

    return questions;
}